import axios from 'axios';
import { apiNotificationsEmailsForEmailTemplateUrl } from '../config';

/**
 * POST Post Put Instance Links.
 *
 * @author Ray Xie <ray.xie@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {[]} [props.emailsToCreate]
 * @param {{}} [props.emailTemplateUUID]
 * @param {{}} [props.method=post] - post | put
 * @param {{}} [props.type=post] - post | put
 * @returns {Promise}
 */

 const postNotificationsEmailsForEmailTemplate = props => {
   const {
     emailTemplateUUID,
     emailsToCreate,
     method = 'post',
     requestConfig,
   } = props;

   if (!emailTemplateUUID) {
     return Promise.reject(new Error('Missing emailTemplateUUID'));
   }

   const url = apiNotificationsEmailsForEmailTemplateUrl.replace(
     '{emailTemplateUUID}',
     emailTemplateUUID
   );

   return axios({
     data: emailsToCreate,
     method,
     url,
     ...requestConfig
   });
 };

export default postNotificationsEmailsForEmailTemplate;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/postNotificationsEmailsForEmailTemplate.js